export class StepInfo {
  helpTitle : string;
  content : string;
  timestamp : number;
  id?: string;
}
